"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
// ChevronDownIcon حذف شد چون میخواستید آیکون دستی خودتان را داشته باشید

import { cn } from "@/lib/utils";

function Accordion({ ...props }) {
  // اعمال dir="rtl" روی روت باعث می‌شود تمام انیمیشن‌ها و چیدمان‌ها راست‌چین شود
  return <AccordionPrimitive.Root dir="rtl" data-slot="accordion" {...props} />;
}

function AccordionItem({ className, ...props }) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      // حذف border-b طبق خواسته قبلی شما
      className={cn("border-none", className)} 
      {...props}
    />
  );
}

function AccordionTrigger({ className, children, asHeading = true, ...props }) {
  const trigger = (
    <AccordionPrimitive.Trigger
      data-slot="accordion-trigger"
      className={cn(
        "focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-4 text-right text-sm font-medium transition-all outline-none hover:no-underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    >
      {children}
      {/* آیکون فلش پیش‌فرض از اینجا حذف شد */}
    </AccordionPrimitive.Trigger>
  );

  // Radix Accordion.Header renders as <h3> by default. Use asChild + div when
  // the trigger label is UI chrome (e.g. filter names), not a document heading.
  if (!asHeading) {
    return (
      <AccordionPrimitive.Header asChild>
        <div className="flex">{trigger}</div>
      </AccordionPrimitive.Header>
    );
  }

  return (
    <AccordionPrimitive.Header className="flex">{trigger}</AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm transition-all [animation-duration:150ms]"
      {...props}>
      <div className={cn("pt-0 pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };